import { setTasksVisualizationSort as setTasksVisualizationSortDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Props = ApiMethodBase & {
    sort?: String,
}

export const setTasksVisualizationSort = ({
    sort,
    eventEmitter,
}: Props) => {
    setTasksVisualizationSortDiagram(sort);
};

